import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isLoading, isAuthenticated, isAdmin } = useAuth()

  // Overlay de carga en index.html (spinner + logo). Mostrar/ocultar por API global.
  useEffect(() => {
    if (typeof window === 'undefined' || !window.__showLoadingOverlay) return
    if (isLoading) {
      window.__showLoadingOverlay('Verificando autenticación...')
    } else {
      window.__hideLoadingOverlay()
    }
    return () => { window.__hideLoadingOverlay && window.__hideLoadingOverlay() }
  }, [isLoading])

  // Verificar si el modal de compartir está abierto - NO redirigir si está abierto
  const savedShowModal = typeof window !== 'undefined' ? sessionStorage.getItem('pdfEditor_showShareModal') : null
  const isModalOpen = savedShowModal === 'true'

  // Si está cargando, no renderizar contenido (el overlay se muestra vía useEffect)
  if (isLoading) {
    return null
  }

  // Si no está autenticado después de cargar, redirigir SOLO si el modal NO está abierto
  if (!isAuthenticated()) {
    if (isModalOpen) {
      console.log('[ProtectedRoute] 🚫 BLOQUEANDO redirección a /login - modal de compartir está abierto')
      // Devolver los children aunque no esté autenticado para evitar que se cierre el modal
      return children
    }
    return <Navigate to="/login" replace />
  }

  if (requireAdmin && !isAdmin()) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 p-4 rounded-lg max-w-md mx-auto">
            <h2 className="text-lg font-semibold text-red-800 mb-2">
              Acceso Denegado
            </h2>
            <p className="text-red-600">
              No tienes permisos para acceder a esta página.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute

